// The name of the fabrication order a resource belongs to, or '' when it has none.
//
// Only parts carry one. The backend fills `fabricationOrder` ({id, code, name}) solely when the
// resource is a Part that has an order, and leaves it null for fixtures, tools and raw material.
// Returning '' for every one of those lets each caller render nothing at all -- never an empty
// label next to a fixture -- without repeating the check in every screen.
//
// Only the NAME is shown, not the code: that is the scope of this change, and the name is the part
// an operator recognises on the floor.
const fabricationOrderName = (resource) => {
  const name = resource?.fabricationOrder?.name
  return typeof name === 'string' ? name.trim() : ''
}

export { fabricationOrderName }
